import * as React from "react";
import styled, { css } from "styled-components";
import * as _ from "lodash";

import Grid from "src/library/components/Hedron";
import { ITag } from "src/modules/product-tags/api/product-tags.api";
import useProductTagList from "src/core/products/hooks/useProductTagList";

import ProductTag from "./ProductTag";

interface ProductTagListProps {
  productTags: ITag[];
  showAll?: boolean;
}

/**
 * Product Tag List Component
 */
const ProductTagList: React.ReactFCWithChildren<ProductTagListProps> = ({ productTags, showAll }) => {
  const productTagsList = useProductTagList(productTags, showAll);

  return (
    <ProductTagListWrapper>
      {_.map(productTagsList, productTag => (
        <Grid.Box
          key={`product-tag-${productTag.id}`}
          className="product-tag-wrapper"
        >
          <ProductTag
            showTooltip
            {...productTag}
          />
        </Grid.Box>
      ))}
    </ProductTagListWrapper>
  );
};

const ProductTagListWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;

    .product-tag-wrapper {
      margin-right: ${theme.spacing.margins.sm};
      margin-bottom: 5px;

      &:hover {
        cursor: help;
      }

      svg:hover {
        cursor: help;
      }
    }
  `}
`;

export default ProductTagList;
